// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__3TdrH","header":"MessagesList_header__4xvYy","chat":"MessagesList_chat__SXtOL"};